import type { CartItemResponse } from '../../model';
import { getFilteredHalloweenPromoItems } from '../campaign';

export const countReviewableCartProducts = (items: CartItemResponse[]): number =>
  new Set(getFilteredHalloweenPromoItems(items).map((item) => item.productId)).size;
